import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { CheckCircle2, XCircle, ChevronRight, Star, ShieldCheck, Gift, ArrowRight } from 'lucide-react';
const CHECKOUT_URL = 'https://checkoutpuntoebook.store/cart/48115663012096:1';
const CTAButton = ({
  text,
  subtext
}: {
  text: string;
  subtext?: string;
}) => <a href={CHECKOUT_URL} className="block w-full max-w-3xl mx-auto group cursor-pointer no-underline" data-id="element-3">
    <div className="bg-red-600 hover:bg-red-700 text-white rounded-xl p-4 md:p-6 shadow-[0_10px_30px_rgba(220,38,38,0.6)] transform transition-all duration-200 hover:scale-105 hover:-translate-y-1 animate-pulse border-b-4 border-red-800 flex flex-col items-center justify-center text-center" data-id="element-4">
      <div className="flex items-center justify-center space-x-2 w-full" data-id="element-5">
        <span className="text-2xl md:text-4xl font-black uppercase tracking-wide text-shadow-sm" data-id="element-6">
          {text}
        </span>
        <ChevronRight className="w-8 h-8 md:w-10 md:h-10 hidden sm:block" data-id="element-7" />
      </div>
      {subtext && <p className="mt-2 text-sm md:text-base font-semibold text-red-100" data-id="element-8">
          {subtext}
        </p>}
    </div>
  </a>;
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden" data-id="element-9">
      {/* URGENCY BAR */}
      <div className="bg-red-700 text-white text-center py-3 px-4 sticky top-0 z-40 shadow-md" data-id="element-10">
        <p className="text-sm md:text-lg font-bold uppercase tracking-wider flex flex-col sm:flex-row items-center justify-center sm:space-x-2" data-id="element-11">
          <span data-id="element-12">
            ⏳ OFERTA EXPIRA EN: <CountdownTimer data-id="element-13" />
          </span>
          <span className="hidden sm:inline" data-id="element-14">|</span>
          <span className="text-yellow-300 animate-pulse" data-id="element-15">
            🔴 SOLO QUEDAN 3 CUPOS
          </span>
        </p>
      </div>

      {/* SECTION 1: HERO */}
      <section className="pt-12 pb-16 px-4 max-w-5xl mx-auto text-center" data-id="element-16">
        <p className="text-lg md:text-xl font-bold text-gray-600 mb-4 uppercase tracking-widest" data-id="element-17">
          Para docentes de nivel inicial
        </p>
        <h1 className="text-5xl md:text-7xl font-black text-gray-900 mb-2 leading-tight uppercase" data-id="element-18">
          SAGA DOCENTE <span className="text-red-600" data-id="element-19">CREATIVA</span>
        </h1>
        <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-8" data-id="element-20">
          <span className="bg-yellow-300 px-2 py-1 leading-relaxed" data-id="element-21">
            MegaPack Educación Inicial Lista
          </span>
        </h2>

        <a href={CHECKOUT_URL} className="block max-w-3xl mx-auto mb-10 transform transition hover:scale-105" data-id="element-22">
          <img src="https://cdn.magicpatterns.com/uploads/hAGgY36eqxJkfe2HP7e9bn/Diseno_sin_titulo.png" alt="Saga Docente Creativa MegaPack" className="w-full h-auto rounded-xl shadow-2xl" data-id="element-23" />
        </a>

        <div className="max-w-3xl mx-auto text-xl md:text-2xl font-medium text-gray-700 space-y-4 mb-10" data-id="element-24">
          <p data-id="element-25">
            Todo el material de nivel inicial que necesitás, listo para usar.
          </p>
          <p data-id="element-26">Clases claras, creativas y sin pasar horas planificando.</p>
          <p className="font-bold text-red-600 text-2xl md:text-3xl" data-id="element-27">
            Dejá de empezar desde cero cada semana.
          </p>
        </div>

        <CTAButton text="🔴 SÍ, QUIERO ACCEDER AHORA" data-id="element-28" />
        <p className="mt-4 text-gray-600 font-bold flex items-center justify-center" data-id="element-29">
          <ShieldCheck className="w-5 h-5 text-green-500 mr-2" data-id="element-30" />✅ Garantía de
          satisfacción de 7 días
        </p>
      </section>

      {/* SECTION 2: PROBLEM */}
      <section className="py-16 px-4 bg-gray-50 border-y border-gray-200" data-id="element-31">
        <div className="max-w-4xl mx-auto text-center" data-id="element-32">
          <p className="text-xl md:text-2xl font-bold text-gray-500 mb-4" data-id="element-33">
            Si enseñás en nivel inicial, dejame hacerte una pregunta honesta
          </p>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-10 leading-tight" data-id="element-34">
            ¿Te pasa que preparar la clase te cansa más que darla?
          </h2>

          <div className="text-xl md:text-2xl text-gray-700 space-y-4 mb-10 font-medium" data-id="element-35">
            <p data-id="element-36">No porque no sepas enseñar.</p>
            <p data-id="element-37">No porque no seas una buena docente.</p>
            <p className="font-bold text-red-600 bg-yellow-100 inline-block px-2" data-id="element-38">
              Sino porque cada clase parece empezar desde cero.
            </p>
          </div>

          <div className="max-w-md mx-auto text-left bg-white p-8 rounded-xl shadow-lg mb-10 border border-gray-100" data-id="element-39">
            <ul className="space-y-4 text-lg md:text-xl font-semibold text-gray-800" data-id="element-40">
              <li className="flex items-center" data-id="element-41">
                <XCircle className="w-6 h-6 text-red-500 mr-3 flex-shrink-0" data-id="element-42" />{' '}
                Buscar actividades.
              </li>
              <li className="flex items-center" data-id="element-43">
                <XCircle className="w-6 h-6 text-red-500 mr-3 flex-shrink-0" data-id="element-44" />{' '}
                Pensar juegos.
              </li>
              <li className="flex items-center" data-id="element-45">
                <XCircle className="w-6 h-6 text-red-500 mr-3 flex-shrink-0" data-id="element-46" />{' '}
                Preparar materiales.
              </li>
              <li className="flex items-center" data-id="element-47">
                <XCircle className="w-6 h-6 text-red-500 mr-3 flex-shrink-0" data-id="element-48" />{' '}
                Organizar recursos.
              </li>
              <li className="flex items-center" data-id="element-49">
                <XCircle className="w-6 h-6 text-red-500 mr-3 flex-shrink-0" data-id="element-50" />{' '}
                Crear proyectos.
              </li>
            </ul>
          </div>

          <div className="text-2xl md:text-3xl font-bold text-gray-800 space-y-2" data-id="element-51">
            <p data-id="element-52">Y cuando finalmente entrás al aula…</p>
            <p className="text-red-600" data-id="element-53">ya estás cansada.</p>
          </div>

          <p className="mt-10 text-3xl md:text-4xl font-black text-gray-900 uppercase" data-id="element-54">
            Enseñar en el jardín no debería sentirse así.
          </p>
        </div>
      </section>

      {/* SECTION 3: THE PROBLEM NOBODY TALKS ABOUT */}
      <section className="py-16 px-4 bg-white" data-id="element-55">
        <div className="max-w-4xl mx-auto" data-id="element-56">
          <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-10" data-id="element-57">
            Si sos docente de nivel inicial, esto seguramente te resulta
            familiar:
          </h2>

          <div className="bg-red-50 border-l-4 border-red-600 p-6 md:p-8 rounded-r-xl mb-10" data-id="element-58">
            <ul className="space-y-5 text-lg md:text-xl font-medium text-gray-800" data-id="element-59">
              <li className="flex items-start" data-id="element-60">
                <span className="text-red-600 font-bold mr-3" data-id="element-61">✔</span>
                Pasás horas planificando cada semana
              </li>
              <li className="flex items-start" data-id="element-62">
                <span className="text-red-600 font-bold mr-3" data-id="element-63">✔</span>
                Tenés material, pero está desordenado
              </li>
              <li className="flex items-start" data-id="element-64">
                <span className="text-red-600 font-bold mr-3" data-id="element-65">✔</span>
                Guardás PDFs que después no encontrás
              </li>
              <li className="flex items-start" data-id="element-66">
                <span className="text-red-600 font-bold mr-3" data-id="element-67">✔</span>
                Buscás ideas en internet todo el tiempo
              </li>
              <li className="flex items-start" data-id="element-68">
                <span className="text-red-600 font-bold mr-3" data-id="element-69">✔</span>
                Terminás improvisando más de lo que te gustaría
              </li>
            </ul>
          </div>

          <div className="text-center" data-id="element-70">
            <p className="text-xl md:text-2xl font-bold text-gray-700 mb-4" data-id="element-71">
              Lo peor es esa sensación constante de:
            </p>
            <blockquote className="text-2xl md:text-3xl font-black text-gray-900 italic bg-yellow-200 p-6 rounded-lg inline-block shadow-md" data-id="element-72">
              “Podría dar mejores clases… si tuviera todo el material listo.”
            </blockquote>
          </div>
        </div>
      </section>

      {/* SECTION 4: THE SOLUTION (BLACK BACKGROUND) */}
      <section className="py-20 px-4 bg-gray-900 text-white text-center" data-id="element-73">
        <div className="max-w-4xl mx-auto" data-id="element-74">
          <h2 className="text-4xl md:text-6xl font-black mb-6 text-yellow-400 uppercase tracking-wide" data-id="element-75">
            📚 SAGA DOCENTE CREATIVA
          </h2>
          <p className="text-2xl md:text-3xl font-bold mb-4" data-id="element-76">
            Un sistema completo de recursos para docentes de nivel inicial.
          </p>
          <p className="text-xl md:text-2xl text-gray-300 mb-12" data-id="element-77">
            Diseñado para que dejes de improvisar y vuelvas a disfrutar enseñar.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-12 mb-12" data-id="element-78">
            <div className="text-center" data-id="element-79">
              <div className="bg-gray-800 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4 border-2 border-yellow-400" data-id="element-80">
                <span className="text-4xl" data-id="element-81">📂</span>
              </div>
              <p className="text-xl font-bold" data-id="element-82">Abrís el material</p>
            </div>
            <ArrowRight className="w-8 h-8 text-gray-600 hidden md:block" data-id="element-83" />
            <div className="text-center" data-id="element-84">
              <div className="bg-gray-800 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4 border-2 border-yellow-400" data-id="element-85">
                <span className="text-4xl" data-id="element-86">📚</span>
              </div>
              <p className="text-xl font-bold" data-id="element-87">Elegís el tema</p>
            </div>
            <ArrowRight className="w-8 h-8 text-gray-600 hidden md:block" data-id="element-88" />
            <div className="text-center" data-id="element-89">
              <div className="bg-gray-800 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4 border-2 border-yellow-400" data-id="element-90">
                <span className="text-4xl" data-id="element-91">✏️</span>
              </div>
              <p className="text-xl font-bold" data-id="element-92">Lo aplicás en clase</p>
            </div>
          </div>

          <div className="text-3xl md:text-4xl font-black text-red-500 space-y-2 uppercase" data-id="element-93">
            <p data-id="element-94">Sin vueltas.</p>
            <p data-id="element-95">Sin improvisar.</p>
            <p data-id="element-96">Sin perder tiempo.</p>
          </div>
        </div>
      </section>

      {/* SECTION 5: WHAT'S INCLUDED */}
      <section className="py-16 px-4 bg-white" data-id="element-97">
        <div className="max-w-5xl mx-auto" data-id="element-98">
          <h2 className="text-4xl md:text-5xl font-black text-center text-gray-900 mb-12 uppercase" data-id="element-99">
            ¿QUÉ INCLUYE EL MEGAPACK?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-100">
            {[{
            icon: '📗',
            title: 'Tomo 1',
            desc: 'Romper la rutina en el aula'
          }, {
            icon: '📘',
            title: 'Tomo 2',
            desc: 'Actividades que los niños no olvidan'
          }, {
            icon: '📙',
            title: 'Tomo 3',
            desc: 'Proyectos que transforman el aula'
          }, {
            icon: '📕',
            title: 'Tomo 4',
            desc: 'Juegos pedagógicos innovadores'
          }, {
            icon: '📗',
            title: 'Tomo 5',
            desc: 'Recursos creativos para transformar el aula'
          }, {
            icon: '📘',
            title: 'Tomo 6',
            desc: 'Una nueva forma de enseñar'
          }].map((tomo, idx) => <div key={idx} className="flex items-center p-4 bg-gray-50 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition" data-id="element-101">
                <span className="text-4xl mr-4" data-id="element-102">{tomo.icon}</span>
                <div data-id="element-103">
                  <h3 className="font-bold text-xl text-gray-900" data-id="element-104">
                    {tomo.title}
                  </h3>
                  <p className="text-gray-700 font-medium" data-id="element-105">{tomo.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="bg-yellow-50 border-2 border-yellow-400 rounded-xl p-8 max-w-3xl mx-auto text-center" data-id="element-106">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-107">
              Cada tomo incluye:
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left max-w-xl mx-auto" data-id="element-108">
              <p className="flex items-center text-lg font-semibold text-gray-800" data-id="element-109">
                <CheckCircle2 className="w-6 h-6 text-green-600 mr-2" data-id="element-110" />{' '}
                actividades listas
              </p>
              <p className="flex items-center text-lg font-semibold text-gray-800" data-id="element-111">
                <CheckCircle2 className="w-6 h-6 text-green-600 mr-2" data-id="element-112" /> juegos
                pedagógicos
              </p>
              <p className="flex items-center text-lg font-semibold text-gray-800" data-id="element-113">
                <CheckCircle2 className="w-6 h-6 text-green-600 mr-2" data-id="element-114" />{' '}
                proyectos educativos
              </p>
              <p className="flex items-center text-lg font-semibold text-gray-800" data-id="element-115">
                <CheckCircle2 className="w-6 h-6 text-green-600 mr-2" data-id="element-116" />{' '}
                estrategias prácticas
              </p>
              <p className="flex items-center text-lg font-semibold text-gray-800" data-id="element-117">
                <CheckCircle2 className="w-6 h-6 text-green-600 mr-2" data-id="element-118" />{' '}
                recursos creativos
              </p>
            </div>
            <p className="mt-8 text-xl font-bold text-red-600" data-id="element-119">
              Todo organizado para que encuentres rápido lo que necesitás.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 6: BEFORE VS AFTER */}
      <section className="py-16 px-4 bg-gray-100" data-id="element-120">
        <div className="max-w-5xl mx-auto" data-id="element-121">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-122">
            {/* Before */}
            <div className="bg-white p-8 rounded-2xl shadow-xl border-t-8 border-red-500" data-id="element-123">
              <h3 className="text-3xl font-black text-center text-red-600 mb-8 uppercase flex items-center justify-center" data-id="element-124">
                <XCircle className="w-8 h-8 mr-2" data-id="element-125" /> Antes del MegaPack
              </h3>
              <ul className="space-y-4 text-lg font-semibold text-gray-700" data-id="element-126">
                <li className="flex items-center" data-id="element-127">
                  <XCircle className="w-6 h-6 text-red-500 mr-3" data-id="element-128" />{' '}
                  Improvisación constante
                </li>
                <li className="flex items-center" data-id="element-129">
                  <XCircle className="w-6 h-6 text-red-500 mr-3" data-id="element-130" /> Cansancio
                  mental
                </li>
                <li className="flex items-center" data-id="element-131">
                  <XCircle className="w-6 h-6 text-red-500 mr-3" data-id="element-132" /> Clases
                  apuradas
                </li>
                <li className="flex items-center" data-id="element-133">
                  <XCircle className="w-6 h-6 text-red-500 mr-3" data-id="element-134" /> Trabajo
                  extra en casa
                </li>
                <li className="flex items-center" data-id="element-135">
                  <XCircle className="w-6 h-6 text-red-500 mr-3" data-id="element-136" /> Estrés antes
                  de cada clase
                </li>
              </ul>
            </div>

            {/* After */}
            <div className="bg-white p-8 rounded-2xl shadow-xl border-t-8 border-green-500 transform md:scale-105 relative z-10" data-id="element-137">
              <div className="absolute -top-4 -right-4 bg-yellow-400 text-black font-black px-4 py-1 rounded-full shadow-lg transform rotate-12" data-id="element-138">
                ¡TU NUEVA REALIDAD!
              </div>
              <h3 className="text-3xl font-black text-center text-green-600 mb-8 uppercase flex items-center justify-center" data-id="element-139">
                <CheckCircle2 className="w-8 h-8 mr-2" data-id="element-140" /> Después del MegaPack
              </h3>
              <ul className="space-y-4 text-lg font-semibold text-gray-800" data-id="element-141">
                <li className="flex items-center" data-id="element-142">
                  <CheckCircle2 className="w-6 h-6 text-green-500 mr-3" data-id="element-143" />{' '}
                  Clases creativas y organizadas
                </li>
                <li className="flex items-center" data-id="element-144">
                  <CheckCircle2 className="w-6 h-6 text-green-500 mr-3" data-id="element-145" />{' '}
                  Material listo siempre
                </li>
                <li className="flex items-center" data-id="element-146">
                  <CheckCircle2 className="w-6 h-6 text-green-500 mr-3" data-id="element-147" /> Más
                  seguridad al enseñar
                </li>
                <li className="flex items-center" data-id="element-148">
                  <CheckCircle2 className="w-6 h-6 text-green-500 mr-3" data-id="element-149" /> Menos
                  trabajo fuera del aula
                </li>
                <li className="flex items-center" data-id="element-150">
                  <CheckCircle2 className="w-6 h-6 text-green-500 mr-3" data-id="element-151" /> Más
                  tranquilidad para dar clases
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7: BONUSES */}
      <section className="py-20 px-4 bg-white" data-id="element-152">
        <div className="max-w-5xl mx-auto" data-id="element-153">
          <div className="text-center mb-16" data-id="element-154">
            <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-4 uppercase flex items-center justify-center" data-id="element-155">
              <Gift className="w-12 h-12 text-red-600 mr-4" data-id="element-156" /> BONOS INCLUIDOS
              HOY
            </h2>
            <p className="text-xl text-gray-600 font-medium" data-id="element-157">
              Llevate todo esto completamente GRATIS con tu compra hoy.
            </p>
          </div>

          <div className="space-y-16" data-id="element-158">
            {/* Bono 1 */}
            <div className="flex flex-col md:flex-row items-center gap-8 bg-gray-50 p-8 rounded-2xl border border-gray-200 shadow-lg" data-id="element-159">
              <div className="w-full md:w-1/2" data-id="element-160">
                <a href={CHECKOUT_URL} className="block cursor-pointer" data-id="element-161">
                  <img src="https://cdn.magicpatterns.com/uploads/gxVMqTK3kvHWV72hFFWzaX/ChatGPT_Image_7_mar_2026,_06_53_23_p.m..png" alt="Bono 1" className="w-full max-w-md mx-auto aspect-square object-cover rounded-xl shadow-md hover:scale-105 transition duration-300" data-id="element-162" />
                </a>
              </div>
              <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-163">
                <h3 className="text-3xl font-black text-gray-900 mb-4" data-id="element-164">
                  🎁 Bono #1 – Plantillas de planificación creativa
                </h3>
                <div className="text-2xl font-bold text-gray-500 line-through mb-2" data-id="element-165">
                  Valor: $19800
                </div>
                <div className="text-4xl font-black text-green-600 bg-green-100 inline-block px-4 py-2 rounded-lg" data-id="element-166">
                  HOY: GRATIS
                </div>
              </div>
            </div>

            {/* Bono 2 */}
            <div className="flex flex-col md:flex-row-reverse items-center gap-8 bg-gray-50 p-8 rounded-2xl border border-gray-200 shadow-lg" data-id="element-167">
              <div className="w-full md:w-1/2" data-id="element-168">
                <a href={CHECKOUT_URL} className="block cursor-pointer" data-id="element-169">
                  <img src="https://cdn.magicpatterns.com/uploads/suQPqjr5bSwm97xKQzi4EV/ChatGPT_Image_7_mar_2026,_06_55_25_p.m..png" alt="Bono 2" className="w-full max-w-md mx-auto aspect-square object-cover rounded-xl shadow-md hover:scale-105 transition duration-300" data-id="element-170" />
                </a>
              </div>
              <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-171">
                <h3 className="text-3xl font-black text-gray-900 mb-4" data-id="element-172">
                  🎁 Bono #2 – 100 actividades rápidas para el aula
                </h3>
                <div className="text-2xl font-bold text-gray-500 line-through mb-2" data-id="element-173">
                  Valor: $15560
                </div>
                <div className="text-4xl font-black text-green-600 bg-green-100 inline-block px-4 py-2 rounded-lg" data-id="element-174">
                  HOY: GRATIS
                </div>
              </div>
            </div>

            {/* Bono 3 */}
            <div className="flex flex-col md:flex-row items-center gap-8 bg-gray-50 p-8 rounded-2xl border border-gray-200 shadow-lg" data-id="element-175">
              <div className="w-full md:w-1/2" data-id="element-176">
                <a href={CHECKOUT_URL} className="block cursor-pointer" data-id="element-177">
                  <img src="https://cdn.magicpatterns.com/uploads/5KCkpJV49Vp4v1ft1MVyew/ChatGPT_Image_7_mar_2026,_06_56_44_p.m..png" alt="Bono 3" className="w-full max-w-md mx-auto aspect-square object-cover rounded-xl shadow-md hover:scale-105 transition duration-300" data-id="element-178" />
                </a>
              </div>
              <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-179">
                <h3 className="text-3xl font-black text-gray-900 mb-4" data-id="element-180">
                  🎁 Bono #3 – 50 juegos pedagógicos con materiales simples
                </h3>
                <div className="text-2xl font-bold text-gray-500 line-through mb-2" data-id="element-181">
                  Valor: $12000
                </div>
                <div className="text-4xl font-black text-green-600 bg-green-100 inline-block px-4 py-2 rounded-lg" data-id="element-182">
                  HOY: GRATIS
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-183">
            <p className="text-2xl md:text-3xl font-black text-red-600 bg-yellow-200 inline-block px-6 py-3 rounded-xl animate-pulse" data-id="element-184">
              ⚠️ Estos bonos son GRATIS solo por hoy
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 8: PRICE (BLACK BACKGROUND) */}
      <section className="py-20 px-4 bg-gray-900 text-white" data-id="element-185">
        <div className="max-w-4xl mx-auto text-center" data-id="element-186">
          <h2 className="text-4xl md:text-5xl font-black mb-10 uppercase text-yellow-400" data-id="element-187">
            Todo lo que recibís hoy
          </h2>

          <div className="bg-gray-800 p-8 rounded-2xl border-2 border-gray-700 max-w-2xl mx-auto mb-10 text-left shadow-2xl" data-id="element-188">
            <ul className="space-y-4 text-xl font-bold" data-id="element-189">
              <li className="flex items-center" data-id="element-190">
                <CheckCircle2 className="w-6 h-6 text-green-400 mr-3" data-id="element-191" /> 6 tomos
                de la saga docente creativa
              </li>
              <li className="flex items-center" data-id="element-192">
                <CheckCircle2 className="w-6 h-6 text-green-400 mr-3" data-id="element-193" /> Bono
                #1: plantillas de planificación
              </li>
              <li className="flex items-center" data-id="element-194">
                <CheckCircle2 className="w-6 h-6 text-green-400 mr-3" data-id="element-195" /> Bono
                #2: 100 actividades rápidas
              </li>
              <li className="flex items-center" data-id="element-196">
                <CheckCircle2 className="w-6 h-6 text-green-400 mr-3" data-id="element-197" /> Bono
                #3: juegos pedagógicos
              </li>
              <li className="flex items-center" data-id="element-198">
                <CheckCircle2 className="w-6 h-6 text-green-400 mr-3" data-id="element-199" /> acceso
                inmediato
              </li>
              <li className="flex items-center" data-id="element-200">
                <CheckCircle2 className="w-6 h-6 text-green-400 mr-3" data-id="element-201" />{' '}
                descarga digital
              </li>
              <li className="flex items-center" data-id="element-202">
                <CheckCircle2 className="w-6 h-6 text-green-400 mr-3" data-id="element-203" /> acceso
                de por vida
              </li>
            </ul>
          </div>

          <div className="mb-10" data-id="element-204">
            <p className="text-2xl md:text-3xl font-bold text-gray-400 mb-2" data-id="element-205">
              Precio regular: <span className="line-through" data-id="element-206">$49.990</span>
            </p>
            <p className="text-3xl md:text-4xl font-black text-yellow-400 mb-2" data-id="element-207">
              HOY SOLO
            </p>
            <p className="text-7xl md:text-9xl font-black text-white text-shadow-md" data-id="element-208">
              $19.990
            </p>
          </div>

          <CTAButton text="🔴 OBTENER MI MEGAPACK AHORA" data-id="element-209" />
        </div>
      </section>

      {/* SECTION 10: TESTIMONIALS */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-210">
        <div className="max-w-5xl mx-auto" data-id="element-211">
          <h2 className="text-4xl font-black text-center text-gray-900 mb-12 uppercase" data-id="element-212">
            Lo que dicen otras docentes
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-213">
            {[{
            name: 'María Fernández',
            age: '34 años',
            city: 'Buenos Aires',
            text: 'Antes pasaba horas buscando actividades. Ahora tengo todo listo.'
          }, {
            name: 'Laura Gómez',
            age: '29 años',
            city: 'Córdoba',
            text: 'Me ahorra muchísimo tiempo cada semana.'
          }, {
            name: 'Paula Martínez',
            age: '41 años',
            city: 'Rosario',
            text: 'Mis clases ahora son mucho más creativas.'
          }, {
            name: 'Ana López',
            age: '37 años',
            city: 'Mendoza',
            text: 'Es el recurso más práctico que encontré para nivel inicial.'
          }, {
            name: 'Daniela Torres',
            age: '32 años',
            city: 'La Plata',
            text: 'Lo uso todos los días en el aula.'
          }].map((t, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-214">
                <div className="flex text-yellow-400 mb-3" data-id="element-215">
                  {[...Array(5)].map((_, idx) => <Star key={idx} className="w-5 h-5 fill-current" data-id="element-216" />)}
                </div>
                <p className="text-lg font-medium text-gray-800 mb-4 italic" data-id="element-217">
                  "{t.text}"
                </p>
                <div className="border-t pt-4 mt-auto" data-id="element-218">
                  <p className="font-bold text-gray-900" data-id="element-219">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-220">
                    {t.age} — {t.city}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 11: FAQ */}
      <section className="py-16 px-4 bg-white" data-id="element-221">
        <div className="max-w-3xl mx-auto" data-id="element-222">
          <h2 className="text-4xl font-black text-center text-gray-900 mb-10 uppercase" data-id="element-223">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-6" data-id="element-224">
            <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-225">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-226">
                ¿Es material digital?
              </h3>
              <p className="text-lg text-gray-700" data-id="element-227">
                Sí. Acceso y descarga inmediata.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-228">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-229">
                ¿Sirve para cualquier jardín?
              </h3>
              <p className="text-lg text-gray-700" data-id="element-230">
                Sí. Está pensado para nivel inicial.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-231">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-232">
                ¿Necesito experiencia previa?
              </h3>
              <p className="text-lg text-gray-700" data-id="element-233">
                No. Todo está explicado paso a paso.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FINAL SECTION */}
      <section className="py-20 px-4 bg-gray-900 text-white text-center border-t-8 border-red-600" data-id="element-234">
        <div className="max-w-4xl mx-auto" data-id="element-235">
          <h2 className="text-4xl md:text-6xl font-black mb-6 uppercase text-yellow-400" data-id="element-236">
            Enseñar puede volver a ser simple
          </h2>
          <div className="text-2xl md:text-3xl font-bold mb-12 space-y-2" data-id="element-237">
            <p data-id="element-238">No necesitás más material.</p>
            <p data-id="element-239">Necesitás un sistema que te ayude todo el año.</p>
          </div>

          <CTAButton text="🔴 ACCEDER AHORA A LA SAGA DOCENTE CREATIVA" data-id="element-240" />

          <p className="mt-8 text-gray-400 font-medium" data-id="element-241">
            Pago 100% seguro y encriptado.
          </p>
        </div>
      </section>
    </div>;
}